import { render, staticRenderFns } from "./HeadlessBanners.vue?vue&type=template&id=35d911c1&"
import script from "./HeadlessBanners.vue?vue&type=script&lang=ts&"
export * from "./HeadlessBanners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports